// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trainerH4_wrapper_usOdY","tablet":"trainerH4_tablet_2HnlN","inner":"trainerH4_inner_1QSP2","text":"trainerH4_text_2J14Z"};